export enum UserGymLocationStatus {
  ACTIVE = 'Active',
  SUSPENDED = 'Suspended',
  INACTIVE = 'Inactive',
  MAIN = 'Main',
}
